export const BackgroundTypes = {
  SOLID: 0,
  GRADIENT: 1,
  IMAGE: 2,
};

const GradientDirections = {
  TO_BOTTOM: 'bottom',
  TO_TOP: 'top',
  TO_RIGHT: 'right',
  TO_LEFT: 'left',
  TO_TOP_RIGHT: 'right top',
  TO_BOTTOM_RIGHT: 'right bottom',
  TO_BOTTOM_LEFT: 'left bottom',
  TO_TOP_LEFT: 'left top',
};

export const GradientDirectionOptions = Object
  .keys(GradientDirections)
  .map(key => ({
    value: GradientDirections[key],
    icon: require(`@/assets/icons/optimized/directions/${key.toLowerCase()}.svg`),
  }));

export const InitialBackgroundValue = {
  [BackgroundTypes.SOLID]: '#f4f5f7',
  [BackgroundTypes.GRADIENT]: 'linear-gradient(to bottom, #000000 0%, #ffffff 100%)',
  [BackgroundTypes.IMAGE]: {
    backgroundImage: 'none',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundAttachment: 'fixed',
  },
};

export const backgroundSizeOptions = [
  {
    value: 'cover',
    label: 'Fill',
  },
  {
    value: 'contain',
    label: 'Contain',
  },
];

export const backgroundPositionOptions = [
  {
    value: 'top',
    label: 'Top',
  },
  {
    value: 'bottom',
    label: 'Bottom',
  },
  {
    value: 'left',
    label: 'Left',
  },
  {
    value: 'right',
    label: 'Right',
  },
  {
    value: 'center',
    label: 'Center',
  },
];

export const fontOptions = [
  {
    value: '"Fredericka the Great", serif',
    label: 'Fredericka the Great',
  },
  {
    value: '"Mountains of Christmas", serif',
    label: 'Mountains of Christmas',
  },
  {
    value: '"Shadows Into Light", cursive',
    label: 'Shadows Into Light',
  },
  {
    value: '"Style Script", cursive',
    label: 'Style Script',
  },
  {
    value: '"Vina Sans", sans-serif',
    label: 'Vina Sans',
  },
  {
    value: '"Pulp Display", sans-serif',
    label: 'Pulp Display',
  },
  {
    value: '"Abril Fatface", cursive',
    label: 'Abril Fatface',
  },
  {
    value: '"Playfair Display", serif',
    label: 'Playfair Display',
  },
  {
    value: '"Oswald", sans-serif',
    label: 'Oswald',
  },
  {
    value: '"Bebas Neue", cursive',
    label: 'Bebas Neue',
  },
  {
    value: '"Roboto Mono", monospace',
    label: 'Roboto Mono',
  },
  {
    value: '"Raleway", sans-serif',
    label: 'Raleway',
    needUpgrade: true,
  },
  {
    value: '"Poppins", sans-serif',
    label: 'Poppins',
    needUpgrade: true,
  },
  {
    value: '"Jost", sans-serif',
    label: 'Jost',
    needUpgrade: true,
  },
  {
    value: '"Nunito", sans-serif',
    label: 'Nunito',
    needUpgrade: true,
  },
  {
    value: '"Kanit", sans-serif',
    label: 'Kanit',
    needUpgrade: true,
  },
  {
    value: '"Forum", cursive',
    label: 'Forum',
    needUpgrade: true,
  },
  {
    value: '"Nanum Myeongjo", serif',
    label: 'Nanum Myeongjo',
    needUpgrade: true,
  },
  {
    value: '"Lobster", cursive',
    label: 'Lobster',
    needUpgrade: true,
  },
  {
    value: '"Pompiere", cursive',
    label: 'Pompiere',
    needUpgrade: true,
  },
  {
    value: '"Edu TAS Beginner", cursive',
    label: 'Edu TAS Beginner',
    needUpgrade: true,
  },
  {
    value: '"Bangers", sans-serif',
    label: 'Bangers',
    needUpgrade: true,
  },
  {
    value: '"Caveat", cursive',
    label: 'Caveat',
    needUpgrade: true,
  },
  {
    value: '"Amatic SC", cursive',
    label: 'Amatic SC',
    needUpgrade: true,
  },
  {
    value: '"VT323", monospace',
    label: 'VT323',
    needUpgrade: true,
  },
  {
    value: '"Rampart One", cursive',
    label: 'Rampart One',
    needUpgrade: true,
  },
];


export const WidgetShapes = {
  OVAL: 0,
  ROUNDED: 1,
  SQUARE: 2,
  OVAL_OUTLINE: 3,
  ROUNDED_OUTLINE: 4,
  SQUARE_OUTLINE: 5,
  OVAL_TRANSPARENT: 6,
  ROUNDED_TRANSPARENT: 7,
  SQUARE_TRANSPARENT: 8,
  DOTTED_SPECIAL: 9,
  SQUARE_OVER_SPECIAL: 10,
  SIDE_SQUARES_SPECIAL: 11,
  BLUR_SPECIAL: 12,
  SHADOW_BOTTOM_SPECIAL: 13,
  RIPPED_SPECIAL: 14,
  HALF_TRANSPARENT_SPECIAL: 15,
};

export const WidgetShapesWithUnavailableBoxShadow = [
  WidgetShapes.RIPPED_SPECIAL,
  WidgetShapes.SHADOW_BOTTOM_SPECIAL,
  WidgetShapes.BLUR_SPECIAL,
  WidgetShapes.SQUARE_OVER_SPECIAL,
  WidgetShapes.SIDE_SQUARES_SPECIAL,
];

export const WidgetShapesWithUnavailableBackground = [
  WidgetShapes.OVAL_TRANSPARENT,
  WidgetShapes.ROUNDED_TRANSPARENT,
  WidgetShapes.SQUARE_TRANSPARENT,
  WidgetShapes.SQUARE_OVER_SPECIAL,
];

export const widgetShapeOptions = [
  {
    groupName: 'Fill',
    shapes: [
      {
        value: WidgetShapes.OVAL,
        mobileIcon: require('@/assets/icons/optimized/widget-shapes/oval-mobile.svg'),
        desktopIcon: require('@/assets/icons/optimized/widget-shapes/oval-desktop.svg'),
      },
      {
        value: WidgetShapes.ROUNDED,
        mobileIcon: require('@/assets/icons/optimized/widget-shapes/rounded-mobile.svg'),
        desktopIcon: require('@/assets/icons/optimized/widget-shapes/rounded-desktop.svg'),
      },
      {
        value: WidgetShapes.SQUARE,
        mobileIcon: require('@/assets/icons/optimized/widget-shapes/square-mobile.svg'),
        desktopIcon: require('@/assets/icons/optimized/widget-shapes/squared-desktop.svg'),
      },
    ],
  },
  {
    groupName: 'Outline',
    shapes: [
      {
        value: WidgetShapes.OVAL_OUTLINE,
        mobileIcon: require('@/assets/icons/optimized/widget-shapes/oval-outline-mobile.svg'),
        desktopIcon: require('@/assets/icons/optimized/widget-shapes/oval-outline-desktop.svg'),
      },
      {
        value: WidgetShapes.ROUNDED_OUTLINE,
        mobileIcon: require('@/assets/icons/optimized/widget-shapes/rounded-outline-mobile.svg'),
        desktopIcon: require('@/assets/icons/optimized/widget-shapes/rounded-outline-desktop.svg'),
      },
      {
        value: WidgetShapes.SQUARE_OUTLINE,
        mobileIcon: require('@/assets/icons/optimized/widget-shapes/square-outline-mobile.svg'),
        desktopIcon: require('@/assets/icons/optimized/widget-shapes/square-outline-desktop.svg'),
      },
    ],
  },
  {
    groupName: 'Transparent',
    shapes: [
      {
        value: WidgetShapes.OVAL_TRANSPARENT,
        mobileIcon: require('@/assets/icons/optimized/widget-shapes/oval-transparent-mobile.svg'),
        desktopIcon: require('@/assets/icons/optimized/widget-shapes/oval-transparent-desktop.svg'),
      },
      {
        value: WidgetShapes.ROUNDED_TRANSPARENT,
        mobileIcon: require('@/assets/icons/optimized/widget-shapes/rounded-transparent-mobile.svg'),
        desktopIcon: require('@/assets/icons/optimized/widget-shapes/rounded-transparent-desktop.svg'),
      },
      {
        value: WidgetShapes.SQUARE_TRANSPARENT,
        mobileIcon: require('@/assets/icons/optimized/widget-shapes/square-transparent-mobile.svg'),
        desktopIcon: require('@/assets/icons/optimized/widget-shapes/square-transparent-desktop.svg'),
      },
    ],
  },
  {
    groupName: 'Special',
    shapes: [
      {
        value: WidgetShapes.DOTTED_SPECIAL,
        mobileIcon: require('@/assets/icons/optimized/widget-shapes/dotted-special-mobile.svg'),
        desktopIcon: require('@/assets/icons/optimized/widget-shapes/dotted-special-desktop.svg'),
      },
      {
        value: WidgetShapes.SQUARE_OVER_SPECIAL,
        mobileIcon: require('@/assets/icons/optimized/widget-shapes/square-over-special-mobile.svg'),
        desktopIcon: require('@/assets/icons/optimized/widget-shapes/square-over-desktop.svg'),
      },
      {
        value: WidgetShapes.SIDE_SQUARES_SPECIAL,
        mobileIcon: require('@/assets/icons/optimized/widget-shapes/side-squares-special-mobile.svg'),
        desktopIcon: require('@/assets/icons/optimized/widget-shapes/side-squares-special-desktop.svg'),
      },
      {
        value: WidgetShapes.BLUR_SPECIAL,
        mobileIcon: require('@/assets/icons/optimized/widget-shapes/blur-special-mobile.svg'),
        desktopIcon: require('@/assets/icons/optimized/widget-shapes/blur-special-desktop.svg'),
      },
      {
        value: WidgetShapes.SHADOW_BOTTOM_SPECIAL,
        mobileIcon: require('@/assets/icons/optimized/widget-shapes/shadow-bottom-special-mobile.svg'),
        desktopIcon: require('@/assets/icons/optimized/widget-shapes/shadow-bottom-special-desktop.svg'),
      },
      {
        value: WidgetShapes.RIPPED_SPECIAL,
        mobileIcon: require('@/assets/icons/optimized/widget-shapes/ripped-special-mobile.svg'),
        desktopIcon: require('@/assets/icons/optimized/widget-shapes/ripped-special-desktop.svg'),
      },
      {
        value: WidgetShapes.HALF_TRANSPARENT_SPECIAL,
        mobileIcon: require('@/assets/icons/optimized/widget-shapes/half-transparent-special-mobile.svg'),
        desktopIcon: require('@/assets/icons/optimized/widget-shapes/half-transparent-special-desktop.svg'),
      },
    ],
    isNeedUpgrade: true,
  },
];

export const widgetSettings = {
  [WidgetShapes.OVAL]: {
    '--link-borderRadius': '30px',
    '--link-border': 'none',
    '--link-boxShadow': 'none',
  },
  [WidgetShapes.ROUNDED]: {
    '--link-borderRadius': '10px',
    '--link-border': 'none',
    '--link-boxShadow': 'none',
  },
  [WidgetShapes.SQUARE]: {
    '--link-borderRadius': 'none',
    '--link-border': 'none',
    '--link-boxShadow': 'none',
  },
  [WidgetShapes.OVAL_OUTLINE]: {
    '--link-borderRadius': '30px',
    '--link-border': '2px solid var(--secondary-color)',
    '--link-boxShadow': 'none',
  },
  [WidgetShapes.ROUNDED_OUTLINE]: {
    '--link-borderRadius': '10px',
    '--link-border': '2px solid var(--secondary-color)',
    '--link-boxShadow': 'none',
  },
  [WidgetShapes.SQUARE_OUTLINE]: {
    '--link-borderRadius': 'none',
    '--link-border': '2px solid var(--secondary-color)',
    '--link-boxShadow': 'none',
  },
  [WidgetShapes.OVAL_TRANSPARENT]: {
    '--link-borderRadius': '30px',
    '--link-border': '2px solid var(--secondary-color)',
    '--primary-color': 'transparent',
    '--link-boxShadow': 'none',
  },
  [WidgetShapes.ROUNDED_TRANSPARENT]: {
    '--link-borderRadius': '10px',
    '--link-border': '2px solid var(--secondary-color)',
    '--primary-color': 'transparent',
    '--link-boxShadow': 'none',
  },
  [WidgetShapes.SQUARE_TRANSPARENT]: {
    '--link-borderRadius': 'none',
    '--link-border': '2px solid var(--secondary-color)',
    '--primary-color': 'transparent',
    '--link-boxShadow': 'none',
  },
  [WidgetShapes.DOTTED_SPECIAL]: {
    '--link-borderRadius': 'none',
    '--link-border': '2px dotted var(--secondary-color)',
    '--link-boxShadow': 'none',
  },
  [WidgetShapes.SQUARE_OVER_SPECIAL]: {
    '--link-borderRadius': 'none',
    '--link-border': '2px solid var(--secondary-color)',
    '--link-boxShadow': 'none',
    '--primary-color': 'transparent',
  },
  [WidgetShapes.RIPPED_SPECIAL]: {
    '--link-borderRadius': 'none',
    '--link-border': 'none',
    '--link-boxShadow': 'none',
  },
  [WidgetShapes.BLUR_SPECIAL]: {
    '--link-borderRadius': '10px',
    '--link-border': 'none',
    '--link-boxShadow': 'none',
  },
  [WidgetShapes.SHADOW_BOTTOM_SPECIAL]: {
    '--link-borderRadius': '30px',
    '--link-border': 'none',
    '--link-boxShadow': '0px 7.2426px 14.4852px var(--secondary-color)',
  },
  [WidgetShapes.SIDE_SQUARES_SPECIAL]: {
    '--link-borderRadius': 'none',
    '--link-border': '2px solid var(--secondary-color)',
    '--link-boxShadow': 'none',
  },
  [WidgetShapes.HALF_TRANSPARENT_SPECIAL]: {
    '--link-borderRadius': '30px',
    '--link-border': 'none',
    '--link-boxShadow': 'none',
  },
};

export const Themes = {
  CUSTOM: 0,
  GREY_MIST: {
    value: 1,
    icon: require('@/assets/images/themes/preview/grey-mist.webp'),
    name: 'Grey Mist',
  },
  BLIZZARD: {
    value: 2,
    icon: require('@/assets/images/themes/preview/blizzard.webp'),
    name: 'Blizzard',
  },
  SANDSTORM: {
    value: 3,
    icon: require('@/assets/images/themes/preview/sandstorm.webp'),
    name: 'Sandstorm',
  },
  PINK_SKY: {
    value: 4,
    icon: require('@/assets/images/themes/preview/pink-sky.webp'),
    name: 'Pink Sky',
  },
  BLUE_FROST: {
    value: 5,
    icon: require('@/assets/images/themes/preview/blue-frost.webp'),
    name: 'Blue Frost',
  },
  BLACK_ICE: {
    value: 6,
    icon: require('@/assets/images/themes/preview/black-ice.webp'),
    name: 'Black Ice',
  },
  GRANITE: {
    value: 7,
    icon: require('@/assets/images/themes/preview/granite.webp'),
    name: 'Granite',
  },
  CANDY: {
    value: 8,
    icon: require('@/assets/images/themes/preview/candy.webp'),
    name: 'Candy',
    needUpgrade: true,
  },
  SMILE_AND_WAVE: {
    value: 9,
    icon: require('@/assets/images/themes/preview/smile-and-wave.webp'),
    name: 'Smile & Wave',
    needUpgrade: true,
  },
  FUNKY_FUZZ: {
    value: 10,
    icon: require('@/assets/images/themes/preview/funky-fuzz.webp'),
    name: 'Funky Fuzz',
    needUpgrade: true,
  },
  TRYB_AND_BEYOND: {
    value: 11,
    icon: require('@/assets/images/themes/preview/tryb-and-beyond.webp'),
    name: 'Tryb & Beyond',
    needUpgrade: true,
  },
  TRYB_LIGHT: {
    value: 12,
    icon: require('@/assets/images/themes/preview/tryb-light.webp'),
    name: 'Tryb Light',
    needUpgrade: true,
  },
  NOTICEBOARD: {
    value: 13,
    icon: require('@/assets/images/themes/preview/noticeboard.webp'),
    name: 'Noticeboard',
    needUpgrade: true,
  },
  TORN_TAUPE: {
    value: 14,
    icon: require('@/assets/images/themes/preview/torn-taupe.webp'),
    name: 'Torn Taupe',
    needUpgrade: true,
  },
  PURPLE_HAZE: {
    value: 15,
    icon: require('@/assets/images/themes/preview/purple-haze.webp'),
    name: 'Purple Haze',
  },
  TRYB: {
    value: 16,
    icon: require('@/assets/images/themes/preview/tryb.webp'),
    name: 'Tryb',
  },
  POMPELMO: {
    value: 17,
    icon: require('@/assets/images/themes/preview/pompelmo.webp'),
    name: 'Pompelmo',
  },
  GOLD_PARTY: {
    value: 18,
    icon: require('@/assets/images/themes/preview/gold-party.webp'),
    name: 'Gold Party',
  },
  PERIWINKLE: {
    value: 19,
    icon: require('@/assets/images/themes/preview/periwinkle.webp'),
    name: 'Periwinkle',
  },
  BAHAMA_BLUE: {
    value: 20,
    icon: require('@/assets/images/themes/preview/bahama-blue.webp'),
    name: 'Bahama Blue',
  },
  BERRY: {
    value: 21,
    icon: require('@/assets/images/themes/preview/berry.webp'),
    name: 'Berry',
    needUpgrade: true,
  },
  CALYPSO: {
    value: 22,
    icon: require('@/assets/images/themes/preview/calypso.webp'),
    name: 'Calypso',
    needUpgrade: true,
  },
  COSMIC: {
    value: 23,
    icon: require('@/assets/images/themes/preview/cosmic.webp'),
    name: 'Cosmic',
    needUpgrade: true,
  },
  ASTRO: {
    value: 24,
    icon: require('@/assets/images/themes/preview/astro.webp'),
    name: 'Astro',
    needUpgrade: true,
  },
  FLARE: {
    value: 25,
    icon: require('@/assets/images/themes/preview/flare.webp'),
    name: 'Flare',
    needUpgrade: true,
  },
  NEBULAE: {
    value: 26,
    icon: require('@/assets/images/themes/preview/nebulae.webp'),
    name: 'Nebulae',
    needUpgrade: true,
  },
  FURPLE: {
    value: 27,
    icon: require('@/assets/images/themes/preview/furple.webp'),
    name: 'Furple',
    needUpgrade: true,
  },
  GLASS_BUBBLE: {
    value: 28,
    icon: require('@/assets/images/themes/preview/glass-bubble.webp'),
    name: 'Glass Bubble',
    needUpgrade: true,
  },
  BATH_BOMB: {
    value: 29,
    icon: require('@/assets/images/themes/preview/bath-bomb.webp'),
    name: 'Bath Bomb',
    needUpgrade: true,
  },
  NEON_WAVES: {
    value: 30,
    icon: require('@/assets/images/themes/preview/neon-waves.webp'),
    name: 'Neon Waves',
    needUpgrade: true,
  },
  RETRO_PC: {
    value: 31,
    icon: require('@/assets/images/themes/preview/retro-pc.webp'),
    name: 'Retro PC',
    needUpgrade: true,
  },
  DESIGNED_BY_CHARLOTTE: {
    value: 32,
    icon: require('@/assets/images/themes/preview/designed-by-charlotte.webp'),
    name: 'Tryb x Design by Charlotte',
  },
  ELLEN_KATHRYN_PUMPKIN: {
    value: 33,
    icon: require('@/assets/images/themes/preview/ellen_kathryn_pumpkin.webp'),
    name: 'Tryb x Ellen Kathryn',
  },
  HAPPY_HOLIDAYS: {
    value: 34,
    icon: require('@/assets/images/themes/preview/happy-holidays.webp'),
    name: 'Happy Holidays',
  },
  CANDY_CANE: {
    value: 35,
    icon: require('@/assets/images/themes/preview/candy-cane.webp'),
    name: 'Candy Cane',
  },
  PASTEL_PINES: {
    value: 36,
    icon: require('@/assets/images/themes/preview/pastel-pines.webp'),
    name: 'Pastel Pines',
  },
  GINGHAM_GIFTWRAP: {
    value: 37,
    icon: require('@/assets/images/themes/preview/gingham-giftwrap.webp'),
    name: 'Gingham Giftwrap',
  },
  HANUKKAH_FUNUKKAH: {
    value: 38,
    icon: require('@/assets/images/themes/preview/hanukkah-funukkah.webp'),
    name: 'Hanukkah Funukkah',
  },
};

export const ThemesCategories = [
  {
    categoryTitle: 'Holidays',
    themes: [
      Themes.HAPPY_HOLIDAYS,
      Themes.CANDY_CANE,
      Themes.PASTEL_PINES,
      Themes.GINGHAM_GIFTWRAP,
      Themes.HANUKKAH_FUNUKKAH,
    ],
  },
  {
    categoryTitle: 'Free',
    themes: [
      Themes.GREY_MIST,
      Themes.BLACK_ICE,
      Themes.BLIZZARD,
      Themes.PURPLE_HAZE,
      Themes.SANDSTORM,
      Themes.PINK_SKY,
      Themes.BLUE_FROST,
      Themes.TRYB,
      Themes.POMPELMO,
      Themes.GOLD_PARTY,
      Themes.PERIWINKLE,
      Themes.BAHAMA_BLUE,
      Themes.GRANITE,
    ],
  },
  {
    categoryTitle: 'Pro',
    themes: [
      Themes.SMILE_AND_WAVE,
      Themes.FUNKY_FUZZ,
      Themes.RETRO_PC,
      Themes.TRYB_AND_BEYOND,
      Themes.TRYB_LIGHT,
      Themes.NOTICEBOARD,
      Themes.TORN_TAUPE,
      Themes.BERRY,
      Themes.CALYPSO,
      Themes.CANDY,
      Themes.COSMIC,
      Themes.ASTRO,
      Themes.FLARE,
      Themes.NEBULAE,
      Themes.FURPLE,
      Themes.GLASS_BUBBLE,
      Themes.BATH_BOMB,
      Themes.NEON_WAVES,
    ],
  },
  {
    categoryTitle: 'Collaborations',
    hasProposalCard: true,
    themes: [
      Themes.DESIGNED_BY_CHARLOTTE,
      Themes.ELLEN_KATHRYN_PUMPKIN,
    ],
  },
];

export function HEXToRGB(hex) {
  if (hex.substring(0, 1) === '#') hex = hex.substring(1);

  const r = parseInt(hex.substring(0, 2), 16);
  const g = parseInt(hex.substring(2, 4), 16);
  const b = parseInt(hex.substring(4), 16);

  return `${r}, ${g}, ${b}`;
}
